import React from "react";
import Heading from "../sub-component/heading/heading.sub-component";

const About = () => {
  return (
    <div className="flex flex-col gap-8 lg:gap-12 lg:py-16" id="about">
      <div className="flex justify-center items-center w-full pt-12">
        <div className="max-w-6xl flex gap-4 lg:gap-8 flex-col">
          <h1
            className="text-2xl lg:text-6xl font-bold"
            data-aos="fade-up"
            data-aos-duration={1000}
            data-aos-delay={400}
          >
            We build technology that brings positive change
          </h1>
          <Heading>
            We work with leaders with extraordinary capabilities and leadership
            to create value and profitable businesses, often from ground up. We
            are the software engineering team behind products that touches
            millions of lives and generates millions in profits. We are a team
            of entrepreneurs, hustlers and street smarts. We have worked at top
            product companies such as Microsoft, Google and come from top
            institutes
          </Heading>
        </div>
      </div>
      <div className="flex justify-center items-center w-full h-full">
        <div className="flex flex-col lg:flex-row gap-12 max-w-6xl items-center">
          <div
            className="w-full lg:w-3/5 flex flex-col gap-3 lg:gap-6"
            data-aos="fade-up"
            data-aos-duration={1000}
            data-aos-delay={500}
          >
            <h1 className="text-2xl lg:text-5xl font-bold pt-2">
              Founders Desk
            </h1>
            <Heading>
              On a day to day basis, I run the company with professionalism,
              backed by strong family values. We take limited engagements so we
              can give 100% to each of the engagements. This has been
              consistently recognized and appreciated by our clients since the
              inception of the company and has been deemed a strong
              differentiator from our competitors.
            </Heading>
            <Heading>
              I deeply care about the team members at YTC and do everything in
              my power to empower them so they can work on products they feel
              most passionate about. Our team members’ needs and feedback helps
              to design our policies.
            </Heading>
            <Heading>
              I am also an engineer at heart and write software daily. This
              keeps me grounded, and constantly keeps me on my toes so we can
              invest in R&D and tools to build quality products.
            </Heading>
          </div>
          <div className="w-full lg:w-2/5 flex flex-col gap-8">
            <div className="flex relative justify-center items-center h-[21rem] w-[21rem] border border-[#a0a5e2] rounded-full p-6 bg-white/0 backdrop-blur before:absolute before:h-[18rem] before:rounded-full before:w-[18rem] before:blur-xl before:bg-[#9884e6]">
              <div className="flex h-full w-full bg-primaryBg z-10 rounded-full items-center justify-center">
                <div className="w-full relative flex justify-center items-center hover:scale-125 hover:transition-transform hover:ease-in-out cursor-pointer duration-1000">
                  <div className="w-64 h-64 z-20 rounded-full border-2 p-2 border-yellow-300">
                    <img
                      src="https://i.ibb.co/TgMXhhJ/dp.jpg"
                      alt="profile"
                      className="h-full w-full rounded-full object-cover"
                      data-aos="fade-up"
                      data-aos-duration={1000}
                      data-aos-delay={400}
                    />
                  </div>
                  <div className="w-72 h-72 rounded-full flex justify-center items-center border-primary border-4 border-l-black border-r-black animate-reverse-spin absolute"></div>
                </div>
              </div>
            </div>
            <h1
              className="lg:text-xl pb-4"
              data-aos="fade-up"
              data-aos-duration={1000}
              data-aos-delay={600}
            >
              Tara Chand Kumawat is Web & App Developer with Good level of
              experience in designing and development, producting the Quality
              work. Founder and CEO of the{" "}
              <span className="text-blue-500">
                YTC (Your Tech Company) Pvt. Ltd.
              </span>
            </h1>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;

// dp <a href="https://ibb.co/d549KKX"><img src="https://i.ibb.co/TgMXhhJ/dp.jpg" alt="dp" border="0"></a>
